/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeCustomersRetrieveResponse
 */
export interface StripeCustomersRetrieveResponse {
    /**
     * See https://stripe.com/docs/api/customers/retrieve
     * @type {object}
     * @memberof StripeCustomersRetrieveResponse
     */
    customer: object;
}

/**
 * Check if a given object implements the StripeCustomersRetrieveResponse interface.
 */
export function instanceOfStripeCustomersRetrieveResponse(value: object): value is StripeCustomersRetrieveResponse {
    if (!('customer' in value) || value['customer'] === undefined) return false;
    return true;
}

export function StripeCustomersRetrieveResponseFromJSON(json: any): StripeCustomersRetrieveResponse {
    return StripeCustomersRetrieveResponseFromJSONTyped(json, false);
}

export function StripeCustomersRetrieveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeCustomersRetrieveResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'customer': json['customer'],
    };
}

export function StripeCustomersRetrieveResponseToJSON(json: any): StripeCustomersRetrieveResponse {
    return StripeCustomersRetrieveResponseToJSONTyped(json, false);
}

export function StripeCustomersRetrieveResponseToJSONTyped(value?: StripeCustomersRetrieveResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customer': value['customer'],
    };
}

